export default __webpack_public_path__ + "static/media/service-order.339198bf.svg";